import DOMPurify from 'dompurify';

export function documentHtml(html: string): string {
  // Links remain readable but cannot navigate or fetch remote resources.
  const content = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'strong',
      'em',
      'u',
      's',
      'sup',
      'sub',
      'ul',
      'ol',
      'li',
      'table',
      'thead',
      'tbody',
      'tr',
      'th',
      'td',
      'blockquote',
      'pre',
      'code',
      'hr',
      'img',
      'a'
    ],
    ALLOWED_ATTR: ['src', 'alt', 'colspan', 'rowspan'],
    ALLOW_DATA_ATTR: false
  });
  return `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1">
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data:; style-src 'unsafe-inline'; base-uri 'none'; form-action 'none'">
<style>body{margin:0;padding:32px;background:white;color:#202b38;font:16px/1.6 Arial,sans-serif;overflow-wrap:anywhere}img{max-width:100%;height:auto}table{border-collapse:collapse;width:100%}td,th{border:1px solid #cbd2da;padding:8px;vertical-align:top}pre{white-space:pre-wrap}h1,h2,h3{line-height:1.25}@media screen and (max-width:600px){body{padding:16px}table{display:block;overflow-x:auto}td,th{min-width:6em}} </style></head><body>${content}</body></html>`;
}
